import { analytics } from './FireBase'

export function logEvent(e) {
  analytics.logEvent(e)
}
